import React from 'react';
import classNames from 'classnames';

interface AuthLogoProps {
    currentApp: string;
    cdn?: string;
    className?: string;
    [key: string]: any;
}

export default AuthLogo;

export const LOGO_APP_CCX = 'ccx';
export const LOGO_APP_CCX_SIDER = 'ccx_sider';
export const LOGO_APP_CCX_SIDER_BG = 'ccx_sider_bg';
export const LOGO_APP_LABS = 'labs';
export const LOGO_APP_LABS_WHITE = 'labs_white';
export const LOGO_APP_LABS_BLACK = 'labs_black';

export function getPrimaryLogoProps(app, cdn) {
    switch (app) {
        case LOGO_APP_LABS:
            return {
                alt: 'S9S Labs',
                src: `${cdn}/labs/logo/s9slabs.svg`,
                style: {
                    width: `200px`,
                    marginBottom: '20px',
                },
            };
        case LOGO_APP_LABS_WHITE:
            return {
                alt: 'S9S Labs',
                src: `${cdn}/labs/logo/logo-white.svg`,
                style: {
                    marginBottom: '10px',
                },
            };
        case LOGO_APP_LABS_BLACK:
            return {
                alt: 'S9S Labs',
                src: `${cdn}/labs/logo/logo-black.svg`,
                style: {
                    marginBottom: '10px',
                },
            };

        case LOGO_APP_CCX:
            return {
                alt: 'S9S Labs - CCX',
                src: `${cdn}/ccx/logo/ccx-purple.svg`,
                style: {
                    width: `150px`,
                    height: `36px`,
                    marginBottom: '20px',
                },
            };
        case LOGO_APP_CCX_SIDER:
            return {
                alt: 'S9S Labs - CCX',
                src: `${cdn}/ccx/logo/ccx-purple.svg`,
                style: {
                    width: `320px`,
                    height: `104px`,
                    marginLeft: '-35px',
                },
            };
        default:
        case LOGO_APP_CCX_SIDER_BG:
            return {
                alt: 'S9S Labs - CCX',
                src: `${cdn}/ccx/logo/ccx-white-icon.svg`,
                style: {
                    width: `52vw`,
                    height: `48vw`,
                },
            };
    }
}

/**
 * @name AuthLogo
 * @desc AuthLogo component.
 */
function AuthLogo({
    currentApp,
    cdn = 'https://st.s9s.io',
    className,
    ...rest
}: AuthLogoProps) {
    return (
        <img
            alt={''}
            className={classNames('AuthLogo', className)}
            {...getPrimaryLogoProps(currentApp, cdn)}
            {...rest}
        />
    );
}
